import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs";
import { IUser } from "src/app/models/user.model";
import { ZpDataService } from "src/app/services/zp-data.service";
import { UserInfoService } from "src/app/services/user-info.service";
import { DelegateHelpers } from "src/app/helpers/delegate-helpers";
import { Router, ActivatedRoute } from "@angular/router";
import { SideNavBarVisibilityService } from "src/app/services/side-nav-bar-visibility.service";
import { IDataEntryForm } from "src/app/models/data-entry.model";
import { GetInfoAndPassService } from "../../services/get-info-and-pass.service";
import { ThemeService } from "src/app/theme/theme-service.service";

@Component({
  selector: "app-shared-plan-summary",
  templateUrl: "./shared-plan-summary.component.html",
  styleUrls: ["./shared-plan-summary.component.scss"],
})
export class SharedPlanSummaryComponent implements OnInit, OnDestroy {
  public allMySharedPlans: {}[];
  public filteredSharePlans: {}[];
  public headElements = ["First", "Last"];
  public subscription: Subscription;
  public planCountText = "No plans";
  public myUser: IUser;
  public chosenPlan;
  public showClient = false;
  public mySubscription: Subscription;
  public delegateId: string;
  public sharedPlan;
  public Id;
  public dummySectionTitle = "Shared Plans";
  public hasPlan;
  public id;
  public dataIsLoaded: boolean = false;
  public subscription4: Promise<void>;
  public logoSponsor: boolean;
  public user: any;
  public refCode: any;
  public logoUrl: any;
  public company: string;
  public disabled: boolean = false;
  public assetsPermission: boolean;
  public debtsPermission: boolean;
  public dailyLifePermission: boolean;
  public digitalLifePermission: boolean;
  public wishesPermission: boolean;
  public questionMarkMobile: boolean;
  public activeTheme: any;
  public isDefaultTheme: boolean;
  public sharedPlanUser: any;
  public sharedPlanCategories: any;
  public subscription1: any;
  public hideSponsor: boolean;
  mySharedPlans: any;
  mySharedPlan: Promise<any[]>;

  constructor(
    private zenplansDataProvider: ZpDataService,
    private userInfo: UserInfoService,
    private delegateHelpers: DelegateHelpers,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private getInfoAndPassService: GetInfoAndPassService,
    public themeService: ThemeService,
    public sideNavBarVisibilityService: SideNavBarVisibilityService
  ) {
    this.subscription = this.userInfo.getMessage().subscribe((user) => {
      this.myUser = JSON.parse(user);
      console.log(this.myUser);
    });
    this.activatedRoute.paramMap.subscribe((params) => {
      this.Id = params.get("id");
    });
  }

  async ngOnInit() {
    console.log("mySharedPlan - ", this.mySharedPlan);
    this.activeTheme = this.themeService.active;
    if (this.activeTheme.name != "defaultTheme") {
      this.isDefaultTheme = false;
    }
    // this.updateScreen();
    if (window.screen.width <= 1100) {
      this.questionMarkMobile = true;
    } else {
      this.questionMarkMobile = false;
    }
    this.dataIsLoaded = false;
    this.allMySharedPlans = await this.zenplansDataProvider.getMySharedPlans();

    if (this.allMySharedPlans && this.allMySharedPlans.length > 0) {
      this.sharedPlan = this.allMySharedPlans.find(
        (plan) => plan["Id"] == this.Id
      );
      console.log("this.sharedPlan - ", this.sharedPlan);

      this.sharedPlanCategories = await this.zenplansDataProvider.getPlan(
        this.sharedPlan["clientId"]
      );
      let checkIfSharedPlanIsUpgraded =
        this.zenplansDataProvider.checkIfSharedPlanIsUpgraded(
          this.sharedPlanCategories
        );
      console.log(checkIfSharedPlanIsUpgraded);
      // if (this.sharedPlan.clientPlanVersion < 2 || this.sharedPlan.clientPlanVersion == undefined) {
      //   alert(
      //     "This user is a shared plan who did not upgrade his plan yet. He need to log in first and only then you'll be able to get his plan."
      //   );
      //   this.router.navigate(["/delegate-home-page"]);
      // }
      // this.refCode = this.allMySharedPlans.find(refCode => refCode['clientRefCode'] == this.refCode);
      if (
        this.sharedPlan.clientUserType == "planHolder" &&
        this.sharedPlan.clientRefCode
      ) {
        this.logoUrl = await this.zenplansDataProvider.getLogoUrl(
          this.sharedPlan.clientRefCode
        );
        let sharedPlanRefCodeData =
          await this.zenplansDataProvider.retrieveSharedPlanRefCode(
            this.sharedPlan.clientRefCode
          );
        if (sharedPlanRefCodeData) {
          this.company = sharedPlanRefCodeData.company;
          this.hideSponsor = sharedPlanRefCodeData.hideSponsor;
        }
        this.logoSponsor = true;
      }
      if (this.sharedPlan.assetsPermission == "never") {
        this.assetsPermission = true;
      }
      if (this.sharedPlan.debtsPermission == "never") {
        this.debtsPermission = true;
      }
      if (this.sharedPlan.dailyLifePermission == "never") {
        this.dailyLifePermission = true;
      }
      if (this.sharedPlan.digitalLifePermission == "never") {
        this.digitalLifePermission = true;
      }
      if (this.sharedPlan.wishesPermission == "never") {
        this.wishesPermission = true;
      }
    }
    this.dataIsLoaded = true;
  }

  async view($event, section, plan) {
    this.delegateHelpers.seeSharedPlan(section, plan, this.myUser);
    console.log('plan', plan);
    console.log('section', section);
    if (section == "summary") {
      if (
        plan["assetsPermission"] != "now" &&
        plan["assetsPermission"] != "contributor" &&
        plan["debtsPermission"] != "now" &&
        plan["debtsPermission"] != "contributor" &&
        plan["dailyLifePermission"] != "now" &&
        plan["dailyLifePermission"] != "contributor" &&
        plan["digitalLifePermission"] != "now" &&
        plan["digitalLifePermission"] != "contributor"
      ) {
        this.router.navigate(["/request-access"]);
      }
      await this.delegateHelpers.delegateChooseSharedPlan(plan, this.myUser);
      this.router.navigate(["/financial-summaries"]);
    }
  }

  request($event, plan?) {
    this.getInfoAndPassService.getInfoAndPass(this.sharedPlan);
    this.router.navigate(["/request-access/" + this.sharedPlan.clientId]);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
